/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Recover_InstructionsInputs */



/**
* | output |
* | --- |
* | "Enter your email and we'll send you a new link, even if you never set a password. New here? Go back and use Sign Up." |
*
* @param {Login_Recover_InstructionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_recover_instructions = /** @type {((inputs?: Login_Recover_InstructionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Recover_InstructionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez votre e-mail et nous vous enverrons un nouveau lien, même si vous n'avez jamais défini de mot de passe. Nouveau ? Revenez en arrière et choisissez Inscription.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca su correo y le enviaremos un enlace nuevo, aunque nunca haya definido una contraseña. ¿Es nuevo? Vuelva atrás y use Registrarse.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite seu e-mail e enviaremos um novo link, mesmo que você nunca tenha definido uma senha. É novo aqui? Volte e use Cadastrar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua email e ti invieremo un nuovo link, anche se non hai mai impostato una password. Sei nuovo? Torna indietro e usa Registrati.")
	return /** @type {LocalizedString} */ ("Enter your email and we'll send you a new link, even if you never set a password. New here? Go back and use Sign Up.")
});